// extracted by mini-css-extract-plugin
export default {"Input__label":"style_Input__label__CD9y8","Input__input":"style_Input__input__yk+wF"};